import { deletedFilters } from "helpers/redux";
import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import List from "./list";

export default class Drivers extends Component {
    componentWillUnmount() {
        this.props.clearParams("admindrivers", deletedFilters());
    }

    render() {
        const { match, location } = this.props;
        const rootUrl = `${match.path}/list`;
        return (
            <div className="page-content">
                <Switch location={location}>
                    <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                    <Route
                        exact
                        path={rootUrl}
                        render={() => <List {...this.props} isTable transition="full" title="Все водители" nofilter />}
                    />
                </Switch>
            </div>
        );
    }
}
